import React from "react";


function PackageHeader(props) {

      // Define a color mapping for the 10 artforms.
      const artformColors = {
        music: "#367591",
        sound: "#009FE3",
        film: "#FBF299",
        art: "#E6007E",
        environment: "#6EBC86",
        writing: "#7B6A58",
        activism: "#E24259",
        performance: "#725283",
        video: "#ABD194",
        vr: "#4D4C4C"
      };

      const ctype_icon = props.workshop.ctype == 'onsite' ? 'fa-mountain-sun' : 'fa-globe';
      const ctype_text = props.workshop.ctype == 'onsite' ? 'Onsite workshop' : 'Online workshop';
      const ctype_text2 = props.workshop.ctype == 'onsite' ? 'Full board' : 'Live & interactive';

      const ctype_text3a = props.workshop.ctype == 'onsite' ? 'Transport' : 'Opportunities';
      const ctype_text3b = props.workshop.ctype == 'onsite' ? 'Included' : 'Post-workshop';

      const ctype_icon3 = props.workshop.ctype == 'onsite' ? 'fa-van-shuttle' : 'fa-handshake-angle';
      const ctype_text4 = props.workshop.start_date;
    
      const artformtags =
      props.workshop && props.workshop.artforms
        ? props.workshop.artforms.split(',').map((art, idx) => {
            const trimmedArt = art.trim();
            return (
              <span
                key={idx}
                style={{
                  backgroundColor: artformColors[trimmedArt],
                  color: "white",
                  borderRadius: "8px",
                  padding: "4px 8px",
                  fontSize: "0.9rem",
                  marginRight: "4px",
                  marginBottom: "4px",
                }}
              >
                {trimmedArt}
              </span>
            );
          })
        : <p>Loading artforms...</p>;
    
        const tutorColorClasses = ['txt-gradient-1','txt-gradient-2','txt-gradient-3','txt-gradient-4','txt-gradient-5','txt-gradient-6'];
        const randomTutorClass = tutorColorClasses[Math.floor(Math.random() * tutorColorClasses.length)];

  return (
    <>
      <div className="pd-header">
        <div className=" pd-top row row-cols-lg-4 row-cols-md-2 row-cols-2 gy-4">
        <div className="col">
            <div className="pd-single-info">
              <div className="info-icon">
              <i className={'fa-solid '+ctype_icon}></i>
              </div>
              <div className="info">
                <h6>{ctype_text}</h6>
                <span className="headerTextHighlight">{ctype_text2}</span>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="pd-single-info">
              <div className="info-icon">
              <i className='fa-solid fa-calendar-days'></i>
              </div>
              <div className="info">
                <h6>Duration</h6>
                <span className="headerTextHighlight">{props.workshop.duration}</span>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="pd-single-info">
              <div className="info-icon">
              <i className="fa-solid fa-people-group"></i>
              </div>
              <div className="info">
                <h6>Group Size</h6>
                <span className="headerTextHighlight">{props.workshop.capacity} People</span>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="pd-single-info">
              <div className="info-icon">
              <i className={'fa-solid '+ctype_icon3}></i>
              </div>
              <div className="info">
                <h6>{ctype_text3a}</h6>
                <span className="headerTextHighlight">{ctype_text3b}</span>
              </div>
            </div>
          </div>
        </div>


        <div className="pd-thumb" style={{ position: "relative" }}>
  {!props.workshop.hasplaces && (
    <div
      style={{
        position: "absolute",
        top: 33,
        left: 0,
        width: "130px", // adjust size as needed
        height: "130px",
        backgroundColor: "black",
        clipPath: "polygon(0 0, 100% 0, 0 100%)", // creates a triangle
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 10,
      }}
    >
      <div
  style={{
    transform: "rotate(-45deg) translate(0%, -80%)",
    color: "white",
    fontSize: "1rem",
    textAlign: "center"
  }}
>
  <i className="fa-solid fa-heart-crack" style={{ marginRight: "2px" }}></i><br />
  sold out
</div>
    </div>
  )}
  <img src={props.workshop.course_image} alt={`${props.workshop.title_with} ${props.workshop.tutors}`} />
</div>





        <div className="header-bottom">
          <div className="pd-lavel d-flex justify-content-between align-items-center flex-wrap gap-2">
            <h5 className="location">
            <i className="fa-solid fa-calendar"></i> {ctype_text4}
            </h5>
            <div>{artformtags}</div>
          </div>
          <h2 className="pd-title">{props.workshop.title_with} <span className={randomTutorClass}>{props.workshop.tutors}</span></h2>
        </div>
      </div>
    </>
  );
}

export default PackageHeader;
